(function () {
    document.querySelectorAll('[data-table-select]').forEach(root => {
        const table = root.querySelector('table');
        const bulk = root.querySelector('.bulkbar');
        const chkAll = root.querySelector('[data-check-all]');
        const chkRows = root.querySelectorAll('tbody input[type="checkbox"][data-row]');

        function refresh() {
            const selected = [...chkRows].filter(c => c.checked);
            bulk.classList.toggle('is-visible', selected.length > 0);
            bulk.querySelector('[data-count]')?.replaceChildren(document.createTextNode(String(selected.length)));
            if (chkAll) chkAll.checked = selected.length && selected.length === chkRows.length;
            bulk.dataset.ids = selected.map(c => c.value).join(',');
        }

        chkAll?.addEventListener('change', () => {
            chkRows.forEach(c => c.checked = chkAll.checked);
            refresh();
        });
        chkRows.forEach(c => c.addEventListener('change', refresh));

        // actions
        root.querySelector('[data-bulk-delete]')?.addEventListener('click', () => {
            const ids = bulk.dataset.ids?.split(',').filter(Boolean) || [];
            // démo : on retire visuellement
            ids.forEach(id => {
                const row = table.querySelector(`tr[data-id="${id}"]`);
                row?.remove();
            });
            refresh();
        });

        refresh();
    });
})();
